import React from 'react'
import { Auth0Provider as Auth0ReactProvider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import Config from '../services/config'

interface Auth0ProviderProps {
  children: React.ReactElement
}

export const Auth0Provider: React.FC<Auth0ProviderProps> = ({ children }) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState: any) => {
    console.log('🔐 Auth0 onRedirectCallback triggered with appState:', appState)
    console.log('🔐 Current window location:', window.location.href)
    navigate(appState?.returnTo || window.location.pathname)
  }

  // Use the correct redirect URI based on platform
  const getRedirectUri = () => {
    const isNative = Capacitor.isNativePlatform()
    const platform = Capacitor.getPlatform()

    console.log('Capacitor Platform Debug:', {
      isNative,
      platform,
      windowLocation: window.location.href
    })

    if (isNative) {
      // For mobile apps, use Capacitor's built-in scheme
      const redirectUri = 'capacitor://localhost/callback'
      console.log('🔥 DEBUG: Using Capacitor redirect URI:', redirectUri)
      console.log('🔥 DEBUG: Platform details:', { isNative, platform })
      console.log('📱 Using Capacitor redirect URI:', redirectUri)

      return redirectUri
    } else {
      // For web apps, use the static staging domain
      const redirectUri = 'https://omniiq-mobile-staging.pages.dev/callback'
      console.log('Using web redirect URI:', redirectUri)
      return redirectUri
    }
  }

  return (
    <Auth0ReactProvider
      domain={Config.AUTH0_DOMAIN}
      clientId={Config.AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      useRefreshTokensFallback={false}
      cacheLocation="localstorage"
      skipRedirectCallback={false}
      authorizationParams={{
        redirect_uri: getRedirectUri(),
        audience: Config.AUTH0_AUDIENCE,
        organization: Config.AUTH0_ORG,
        scope: 'openid profile email read:devices read:device_data read:locations read:events read:alarms',
      }}
    >
      {children}
    </Auth0ReactProvider>
  )
}